export default __webpack_public_path__ + "static/media/10.33fc2896.pdf";